var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenOnBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218",
    transform: "translate(-1133 -283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3032",
    "data-name": "Path 3032",
    transform: "translate(1133 283)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,0A34,34,0,1,1,0,34,34,34,0,0,1,34,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34 2 C 29.67914581298828 2 25.48860168457031 2.845802307128906 21.54476547241211 4.513900756835938 C 17.73447799682617 6.125522613525391 14.31205368041992 8.433109283447266 11.37258911132812 11.37258911132812 C 8.433109283447266 14.31205368041992 6.125522613525391 17.73447799682617 4.513900756835938 21.54476547241211 C 2.845802307128906 25.48860168457031 2 29.67914581298828 2 34 C 2 38.32085418701172 2.845802307128906 42.51139831542969 4.513900756835938 46.45523071289062 C 6.125522613525391 50.26552200317383 8.433109283447266 53.68794250488281 11.37258911132812 56.62741088867188 C 14.31205368041992 59.56688690185547 17.73447799682617 61.87447738647461 21.54476547241211 63.48609924316406 C 25.48860168457031 65.15419769287109 29.67914581298828 66 34 66 C 38.32085418701172 66 42.51139831542969 65.15419769287109 46.45523071289062 63.48609924316406 C 50.26552200317383 61.87447738647461 53.68794250488281 59.56688690185547 56.62741088867188 56.62741088867188 C 59.56688690185547 53.68794250488281 61.87447738647461 50.26552200317383 63.48609924316406 46.45523071289062 C 65.15419769287109 42.51139831542969 66 38.32085418701172 66 34 C 66 29.67914581298828 65.15419769287109 25.48860168457031 63.48609924316406 21.54476547241211 C 61.87447738647461 17.73447799682617 59.56688690185547 14.31205368041992 56.62741088867188 11.37258911132812 C 53.68794250488281 8.433109283447266 50.26552200317383 6.125522613525391 46.45523071289062 4.513900756835938 C 42.51139831542969 2.845802307128906 38.32085418701172 2 34 2 M 34 0 C 52.77767944335938 0 68 15.22232055664062 68 34 C 68 52.77767944335938 52.77767944335938 68 34 68 C 15.22232055664062 68 0 52.77767944335938 0 34 C 0 15.22232055664062 15.22232055664062 0 34 0 Z",
    stroke: "none",
    fill: "#0000aa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(1147.001 300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plant",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M15.347,25.3c-3.335-3.333-9.861-3.72-14.48-3.72A.867.867,0,0,0,0,22.446c0,4.619.385,11.145,3.72,14.48a8.072,8.072,0,0,0,5.7,2.037,8.645,8.645,0,0,0,5.923-2.038C17.831,34.44,18.287,28.237,15.347,25.3ZM14.122,35.7c-1.855,1.853-7,2.17-9.175,0C2.255,33.009,1.789,27.54,1.739,23.317c4.222.05,9.691.517,12.383,3.208C16.292,28.7,15.974,33.848,14.122,35.7Z",
    transform: "translate(0 -21.579)",
    fill: "#0000aa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(21.883 3.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M272.38,63.776c-4.619,0-11.145.385-14.48,3.72-2.94,2.938-2.484,9.142,0,11.626a8.648,8.648,0,0,0,5.921,2.037,8.081,8.081,0,0,0,5.706-2.035c3.333-3.335,3.72-9.861,3.72-14.48A.867.867,0,0,0,272.38,63.776ZM268.3,77.9c-2.17,2.17-7.321,1.853-9.174,0s-2.17-7,0-9.175c2.692-2.692,8.16-3.158,12.383-3.208C271.456,69.737,270.99,75.206,268.3,77.9Z",
    transform: "translate(-255.862 -63.776)",
    fill: "#0000aa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(7.476 6.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M109.443,110.924a.936.936,0,0,0-1.222-.383c-6.647,3.125-9.913,8.575-11.4,14.177-1.836-11.912-7.145-15.543-9.4-17.084a5.439,5.439,0,0,1-.621-.452.867.867,0,1,0-1.226,1.226,6.972,6.972,0,0,0,.868.657c2.538,1.735,9.279,6.348,9.279,24.73a.867.867,0,0,0,1.733,0c0-7.427,2-17.219,11.5-21.684,0,0,.14-.068.14-.068A.8.8,0,0,0,109.443,110.924Z",
    transform: "translate(-85.328 -106.928)",
    fill: "#0000aa"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenOnBlue);
export default __webpack_public_path__ + "static/media/green-on-blue.a7b0c3318ba7f40ccc1dc411f7b155a0.svg";
export { ForwardRef as ReactComponent };